import { handleTreeViewCheckChange, processTreeViewItems, TreeView, TreeViewCheckDescriptor, TreeViewExpandChangeEvent } from "@progress/kendo-react-treeview";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { basicTreeSubTitle, SimpleTreeviewData } from "../../../Data/BonusUiData/TreeViewData";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader";
import { BasicTreeTitle } from "../../../Utils/Constants";

export default function BasicTree() {
  const checkField = "checked";

  type TreeState = {
    check: TreeViewCheckDescriptor;
    items: typeof SimpleTreeviewData;
  };

  const [treeState, setTreeState] = useState<TreeState>({
    check: { idField: "text", applyCheckIndeterminate: true, ids: [] },
    items: SimpleTreeviewData,
  });

  const onCheckChange = (event: any) => {
    const settings = { checkChildren: true, checkParents: true };
    const newCheck = handleTreeViewCheckChange(event, treeState.check, treeState.items, settings) as TreeViewCheckDescriptor;
    setTreeState((prevState) => ({
      ...prevState,
      check: { ...prevState.check, ...newCheck },
    }));
  };

  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    event.item.expanded = !event.item.expanded;
    setTreeState((prevState) => ({
      ...prevState,
      items: [...prevState.items],
    }));
  };
  return (
    <Col sm={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={BasicTreeTitle} subTitle={basicTreeSubTitle} />
        <CardBody>
          <TreeView
            data={processTreeViewItems(treeState.items, {
              check: treeState.check,
            })}
            checkField={checkField}
            checkboxes={true}
            onCheckChange={onCheckChange}
            expandIcons={true}
            onExpandChange={onExpandChange}
          />
        </CardBody>
      </Card>
    </Col>
  );
}
